import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "~/lib";
import { API } from "aws-amplify";
import { getTenant } from "~/graphql/queries";
import * as APITypes from "~/API";

/**
 * Check if a tenant exists in Firestore by UID
 */
export const checkFirestoreTenantExists = async (
  uid: string
): Promise<boolean> => {
  try {
    const tenantsCollection = collection(db, "tenants");
    const q = query(tenantsCollection, where("id", "==", uid));
    const querySnapshot = await getDocs(q);
    return !querySnapshot.empty;
  } catch (error) {
    console.error("Error checking Firestore tenant existence", error);
    return false;
  }
};

/**
 * Check if a tenant exists in Firestore by email
 */
export const checkFirestoreTenantExistsByEmail = async (
  email: string
): Promise<boolean> => {
  try {
    const tenantsCollection = collection(db, "tenants");
    const q = query(tenantsCollection, where("email", "==", email));
    const querySnapshot = await getDocs(q);
    return !querySnapshot.empty;
  } catch (error) {
    console.error("Error checking Firestore tenant existence by email", error);
    return false;
  }
};

/**
 * Check if a tenant exists in DynamoDB by ID
 */
export const checkDynamoTenantExists = async (
  tenantId: string
): Promise<boolean> => {
  try {
    const response = (await API.graphql({
      query: getTenant,
      variables: {
        id: tenantId,
      },
    })) as { data?: APITypes.GetTenantQuery };

    return !!response.data?.getTenant;
  } catch (error) {
    // If tenant doesn't exist, GraphQL will throw an error
    return false;
  }
};
